import { GuestGroup } from '../types/interfaces';

/** Whether the group needs the shuttle; undefined if not answered yet. */
export function groupNeedsBus(group: GuestGroup): boolean | undefined {
  if (group.needsBus === true) return true;
  if (group.needsBus === false) return false;
  if (group.busCount !== undefined && group.busCount !== null) {
    return group.busCount > 0;
  }
  return undefined;
}
